import { render, staticRenderFns } from "./RecordTypesSelect.vue?vue&type=template&id=5f274ba9&scoped=true&lang=pug"
import script from "./RecordTypesSelect.vue?vue&type=script&lang=js"
export * from "./RecordTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f274ba9",
  null
  
)

export default component.exports